/**
 * <countdown-timer expires-at="2026-11-05T23:59:00+01:00" expiration-behavior="refresh|hide">
 *
 * On expiry:
 * - refresh: re-renders the section the timer is in via the Section Rendering API,
 *   countdown-engine then renders the next campaign
 * - hide: removes the closest [data-countdown-container] (PDP block)
 */

if (!customElements.get('countdown-timer')) {
	const REFRESH_DELAY = 1000;

	const refreshSection = async (section) => {
		const id = section.id.replace('shopify-section-', '');
		try {
			const response = await fetch(`${location.pathname}?section_id=${id}&countdown=${Date.now()}`);
			if (!response.ok) {
				console.log(`countdown-timer: section refresh failed (${response.status} ${response.statusText})`);
				return;
			}
			section.outerHTML = await response.text();
		} catch (error) {
			console.log(`countdown-timer: section refresh failed (${error.message})`);
			return;
		}
	};

	class CountdownTimer extends HTMLElement {
		connectedCallback() {
			this.expiresAt = new Date(this.getAttribute('expires-at')).getTime();
			if (Number.isNaN(this.expiresAt)) return;

			this.tick();
			this.interval = setInterval(() => this.tick(), 1000);
		}

		disconnectedCallback() {
			clearInterval(this.interval);
		}

		tick() {
			const seconds = Math.max(0, Math.ceil((this.expiresAt - Date.now()) / 1000));
			const values = {
				days: Math.floor(seconds / 86400),
				hours: Math.floor(seconds / 3600) % 24,
				minutes: Math.floor(seconds / 60) % 60,
				seconds: seconds % 60,
			};
			this.querySelectorAll('[data-unit]').forEach((element) => {
				element.textContent = String(values[element.dataset.unit]).padStart(2, '0');
			});

			if (seconds > 0) return;
			clearInterval(this.interval);
			const behavior = this.getAttribute('expiration-behavior');
			if (behavior === 'refresh') this.scheduleRefresh();
			if (behavior === 'hide') this.closest('[data-countdown-container]')?.remove();
		}

		scheduleRefresh() {
			const delay = REFRESH_DELAY;
			setTimeout(() => {
				const section = this.closest('.shopify-section');
				if (section) refreshSection(section);
			}, delay);
		}
	}

	customElements.define('countdown-timer', CountdownTimer);
}
